import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { DropdownComponent } from "../../../common/components/core/dropdown/dropdown.component";
import { NgIf } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { UserFacility } from "src/app/common/interfaces/user.interface";
import { StorageService } from "src/app/common/services/storage.service";

@Component({
  standalone: true,
  selector: "app-facility-selector",
  templateUrl: "./facility-selector.component.html",
  imports: [DropdownComponent, NgIf],
})
export class FacilitySelectorComponent implements OnChanges {
  @Input() set facilities(facilities: UserFacility[]) {
    this._facilities = facilities;
    this.facilityOptions = facilities.map((facility) => ({
      id: facility.facilityid,
      name: facility.facilityname,
    }));
  }
  @Input() initialFacilityIdSelection!: string;
  @Input() facilityProviderNumber: string | undefined;
  @Output() facilityIdSelected: EventEmitter<string> = new EventEmitter();

  _facilities: UserFacility[] = [];
  facilityOptions: { id: string; name: string }[] = [];
  selectedFacility!: UserFacility;

  constructor(private dialog: MatDialog,
    private storageService: StorageService,
  ) {}

  ngOnChanges(): void {
    this.storageService.isSelectedFacility.subscribe((facilityId)=>{
      this.selectedFacility =  this._facilities.find(
      (facility: UserFacility) =>
        facility.facilityid === facilityId
    ) || this._facilities[0]
    });
  }
  // TODO: Guessing the formatting here was intentional, keeping this around in case it needs to come back
  // get displayName() {
  //   return `${this.selectedFacility?.facilityname}${
  //     this.facilityProviderNumber ? ` ID #${this.facilityProviderNumber}` : ""
  //   }`;
  // }


  onOptionSelected(event: any) {
    const facility = this._facilities.find(
      (facility) => facility.facilityid === event.value
    );
    if (facility) {
      this.selectedFacility = facility;
      this.facilityIdSelected.emit(facility.facilityid);
    }
  }
}
